'use client';

import React from 'react';

import {Header as ReactHeader} from '@udemy-v2/react-header';

export const Header = () => {
    return <ReactHeader />;
};

export default Header;
